var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafetyIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.5V23C18.8065 23 17.6619 23.4741 16.818 24.318C15.9741 25.1619 15.5 26.3065 15.5 27.5H14C14 25.9087 14.6321 24.3826 15.7574 23.2574C16.8826 22.1321 18.4087 21.5 20 21.5ZM20 20.75C17.5138 20.75 15.5 18.7362 15.5 16.25C15.5 13.7638 17.5138 11.75 20 11.75C22.4862 11.75 24.5 13.7638 24.5 16.25C24.5 18.7362 22.4862 20.75 20 20.75ZM20 19.25C21.6575 19.25 23 17.9075 23 16.25C23 14.5925 21.6575 13.25 20 13.25C18.3425 13.25 17 14.5925 17 16.25C17 17.9075 18.3425 19.25 20 19.25ZM24.5 27.125L22.2957 28.2838L22.7165 25.8298L20.9338 24.0912L23.3983 23.7327L24.5 21.5L25.6025 23.7327L28.0662 24.0912L26.2835 25.8298L26.7035 28.2838L24.5 27.125Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyIcon2);
export default __webpack_public_path__ + "static/media/safety_icon2.83a13b389fc0e20b116d5f0630001cee.svg";
export { ForwardRef as ReactComponent };